import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserFeedbackDetails } from '../../../../redux/slices/feedbackSlice';
import { FaStar } from 'react-icons/fa';
import { AiOutlineLike, AiOutlineDislike } from 'react-icons/ai';

const UserFeedbackDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { feedbackDetails } = useSelector((state) => state.feedbackSlice);

  useEffect(() => {
    dispatch(getUserFeedbackDetails(id, setIsLoading));
  }, [dispatch, id]);

  const renderRatingAnswer = (rating) => {
    return (
      <div className="d-flex align-items-center">
        {[...Array(5)].map((_, index) => (
          <FaStar
            key={index}
            className={`me-1 ${index < rating ? 'text-warning' : 'text-muted'}`}
            size={20}
          />
        ))}
      </div>
    );
  };

  const renderMCQAnswer = (answers) => {
    return (
      <div className="d-flex flex-wrap gap-2">
        {answers.map((option, index) => (
          <span
            key={index}
            className="badge bg-primary me-2"
          >
            {option}
          </span>
        ))}
      </div>
    );
  };

  const renderLikeDislikeAnswer = (answer) => {
    return (
      <div className="d-flex align-items-center">
        {answer ? (
          <AiOutlineLike className="text-success" size={24} />
        ) : (
          <AiOutlineDislike className="text-danger" size={24} />
        )}
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="page-header">
        <h3 className="page-title">Feedback Details</h3>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {/* User Information */}
              <div className="mb-4">
                <h4 className="card-title">User Information</h4>
                <div className="row">
                  <div className="col-md-6">
                    <p><strong>Name:</strong> {feedbackDetails?.userDetails?.[0]?.fullName}</p>
                    <p><strong>Email:</strong> {feedbackDetails?.userDetails?.[0]?.email}</p>
                    <p><strong>Phone:</strong> {feedbackDetails?.userDetails?.[0]?.phone}</p>
                    <p><strong>Order ID:</strong> {feedbackDetails?.orderId}</p>
                    <p><strong>Date:</strong> {new Date(feedbackDetails?.createdAt).toLocaleDateString()}</p>
                  </div>
                </div>
              </div>

              {/* Rating Questions */}
              {feedbackDetails?.ratingFeedback?.length > 0 && (
                <div className="mb-4">
                  <h4 className="card-title">Rating Questions</h4>
                  <div className="row">
                    {feedbackDetails.ratingFeedback.map((feedback, index) => (
                      <div key={index} className="col-md-6 mb-3">
                        <div className="p-3 border rounded">
                          <p className="mb-2"><strong>Question:</strong> {feedback.questionDetails.question}</p>
                          <p className="mb-0"><strong>Rating:</strong></p>
                          {renderRatingAnswer(parseInt(feedback.ratingAnswers))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* MCQ Questions */}
              {feedbackDetails?.mcqFeedbacks?.length > 0 && (
                <div className="mb-4">
                  <h4 className="card-title">Multiple Choice Questions</h4>
                  <div className="row">
                    {feedbackDetails.mcqFeedbacks.map((feedback, index) => (
                      <div key={index} className="col-md-6 mb-3">
                        <div className="p-3 border rounded">
                          <p className="mb-2"><strong>Question:</strong> {feedback.questionDetails.question}</p>
                          <p className="mb-0"><strong>Selected Options:</strong></p>
                          {renderMCQAnswer(feedback.mcqAnswer)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Like/Dislike Questions */}
              {feedbackDetails?.likeDislikeFeedbacks?.length > 0 && (
                <div className="mb-4">
                  <h4 className="card-title">Like/Dislike Questions</h4>
                  <div className="row">
                    {feedbackDetails.likeDislikeFeedbacks.map((feedback, index) => (
                      <div key={index} className="col-md-6 mb-3">
                        <div className="p-3 border rounded">
                          <p className="mb-2"><strong>Question:</strong> {feedback.questionDetails.question}</p>
                          <p className="mb-0"><strong>Answer:</strong></p>
                          {renderLikeDislikeAnswer(feedback.likeDislikeAnswers)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Other Feedback */}
              {feedbackDetails?.otherFeedbacks && (
                <div className="mb-4">
                  <h4 className="card-title">Additional Feedback</h4>
                  <div className="row">
                    <div className="col-12">
                      <div className="p-3 border rounded">
                        <p className="mb-0">{feedbackDetails.otherFeedbacks}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFeedbackDetails;
 